export enum IamRoleEnum {
  INTERNAL_ADMIN = 'INTERNAL_ADMIN',
  PARTNER_ADMIN = 'PARTNER_ADMIN',
  PARTNER_REQUESTS = 'PARTNER_REQUESTS',
  SEARCH_ADMIN = 'SEARCH_ADMIN',
  SEARCH_MANAGER = 'SEARCH_MANAGER',
  SEARCH_ANALYST = 'SEARCH_ANALYST',
  MERCHANT = 'MERCHANT',
  EXPERIMENT_MAKER = 'EXPERIMENT_MAKER',
  EXPERIMENT_USER = 'EXPERIMENT_USER',
  USER_MANAGER = 'User Manager',
}
